"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInputRootUnderline = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _TextInputRootBase = require("./TextInputRootBase");
var _formInputTheme = require("./formInputTheme");
const TextInputRootUnderline = (0, _styled.default)(_TextInputRootBase.TextInputRootBase)`
    border: ${props => props.themeMode === "oldestar" ? 1 : 2}px solid transparent;
    border-bottom: solid ${_formInputTheme.getBorderColor};
    border-width: ${_formInputTheme.getBorderWidth}px;
    border-radius: ${props => props.themeMode === "oldestar" ? 2 : 4}px;
    background-color: ${getBackgroundColor};
    border-left-width: 0;
    border-right-width: 0;
    border-radius: 0;
`;
exports.TextInputRootUnderline = TextInputRootUnderline;
function getBackgroundColor(_ref) {
  let {
    isDisabled,
    themeMode
  } = _ref;
  if (isDisabled) {
    return _formInputTheme.formInputTheme.backgroundColor.readonly(themeMode);
  } else {
    return _formInputTheme.formInputTheme.backgroundColor.underlined(themeMode);
  }
}
//# sourceMappingURL=TextInputRootUnderline.js.map